export default __webpack_public_path__ + "static/media/logo-mobile.2a332020.svg";